import { computed, inject, Injector } from '@angular/core';
import {
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { initialFeedbackState } from './feedback.state';
import { init, selectType } from './feedback.utility';
import { Energy_Village__Tipo_Feedback_Enum } from '../../_graphql/generated';

export const FeedbackStore = signalStore(
  { providedIn: 'root' },
  // Stato iniziale
  withState(initialFeedbackState),
  withComputed(({ data }) => ({
    rifiuta: computed(() =>
      data?.()?.filter(
        (value) => value.type === Energy_Village__Tipo_Feedback_Enum.Rifiuta,
      ),
    ),
    rifiutaDatiTecnici: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.RifiutaDataTecnici,
      ),
    ),
    rifiutaOpzione: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.RifiutaOpzione,
      ),
    ),
    rigettaDatiTecnici: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.RigettaDatiTecnici,
      ),
    ),
    rigettaDatiPnrr: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.RigettaDatiPnrr,
      ),
    ),
    rigetta: computed(() =>
      data?.()?.filter(
        (value) => value.type === Energy_Village__Tipo_Feedback_Enum.Rigetta,
      ),
    ),
    cancellaRichiesta: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.CancellaRichiesta,
      ),
    ),
    recesso: computed(() =>
      data?.()?.filter(
        (value) => value.type === Energy_Village__Tipo_Feedback_Enum.Recesso,
      ),
    ),
    inviaDisdetta: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.InviaDisdetta,
      ),
    ),
    eliminaRichiesta: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.EliminaRichiesta,
      ),
    ),
    concludiRecesso: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.ConcludiRecesso,
      ),
    ),
    concludiDisdetta: computed(() =>
      data?.()?.filter(
        (value) =>
          value.type === Energy_Village__Tipo_Feedback_Enum.ConcludiDisdetta,
      ),
    ),
  })),
  withMethods((store, injector = inject(Injector)) => ({
    init: init(injector, store),
    selectType: selectType(store),
  })),
);
